"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const microcms_js_sdk_1 = require("microcms-js-sdk");
const plugin = function (_, inject) {
    const _options = JSON.parse('{"serviceDomain":"knowledgeloop-dev","apiKey":"294fdd3894a14f4197d29b07411911132a8f"}');
    const client = microcms_js_sdk_1.createClient(_options);
    inject('microcms', client);
};
exports.default = plugin;
